/**
 * useInvestigationState — a useState that Investigation Memory can snapshot
 * and restore. Components use it for any state that should survive the
 * "Return to Previous Investigation" journey (expanded panels, tabs, views).
 */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as memory from "./investigationMemory";

export const useInvestigationState = (key, initial) => {
  const location = useLocation();
  const url = location.pathname + location.search;
  const [val, setVal] = useState(() => {
    const r = memory.getRestoredValue(url, key);
    return r === undefined ? initial : r;
  });

  useEffect(() => { memory.setStateValue(key, val); }, [key, val]);

  // Late restore: back-navigation can resolve after this hook is already
  // mounted (e.g. focus changes within the same page component).
  useEffect(() => memory.subscribe(() => {
    const cur = window.location.pathname + window.location.search;
    const r = memory.getRestoredValue(cur, key);
    if (r !== undefined) setVal(r);
  }), [key]);

  return [val, setVal];
};
